export const getTagNameList = (tags) => {
  if (!tags) return []
  return Array.from(tags)
    .map((tag) => {
      if (typeof tag === 'string') return tag
      return tag?.label || tag?.tagName || tag?.value
    })
    .filter(Boolean)
}
